function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#75E2EE",
  cx: 30,
  cy: 30,
  r: 30
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 14,
  y: 9,
  fill: "#6A3788",
  width: 33,
  height: 43
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 15,
  y: 10,
  fill: "#F1F1F1",
  width: 30,
  height: 41
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6D6D6D",
  d: "M17.5,13c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1l0,0c0-0.55,0.45-1,1-1h3C17.05,12,17.5,12.45,17.5,13 L17.5,13z"
}));

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6D6D6D",
  d: "M17.5,27c0-0.55-0.45-1-1-1h-3c-0.55,0-1,0.45-1,1l0,0c0,0.55,0.45,1,1,1h3C17.05,28,17.5,27.55,17.5,27 L17.5,27z"
}));

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6D6D6D",
  d: "M17.5,41c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1l0,0c0-0.55,0.45-1,1-1h3C17.05,40,17.5,40.45,17.5,41 L17.5,41z"
}));

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6D6D6D",
  d: "M17.5,20c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1l0,0c0-0.55,0.45-1,1-1h3C17.05,19,17.5,19.45,17.5,20 L17.5,20z"
}));

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6D6D6D",
  d: "M17.5,34c0-0.55-0.45-1-1-1h-3c-0.55,0-1,0.45-1,1l0,0c0,0.55,0.45,1,1,1h3C17.05,35,17.5,34.55,17.5,34 L17.5,34z"
}));

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6D6D6D",
  d: "M17.5,48c0,0.55-0.45,1-1,1h-3c-0.55,0-1-0.45-1-1l0,0c0-0.55,0.45-1,1-1h3C17.05,47,17.5,47.45,17.5,48 L17.5,48z"
}));

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 21.5,
  y: 20,
  fill: "#333333",
  width: 18,
  height: 3
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 21.5,
  y: 28,
  fill: "#333333",
  width: 18,
  height: 2
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 21.5,
  y: 35,
  fill: "#333333",
  width: 18,
  height: 2
});

var SvgCursoLineaLeccion = function SvgCursoLineaLeccion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCursoLineaLeccion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cursoLinea_leccion.25a32a20.svg";
export { ForwardRef as ReactComponent };